import { createContext } from "react"
import { DirectType } from "../api/direct"
import { PlaylistType } from "../api/playlist"
import { VideoType } from "../api/video"

export interface StaticContextType {
  trendingVideos: VideoType[]
  trendingLoading: boolean
  trendingError: { status: number } | null
  reloadTrendingVideos: () => Promise<void>

  latestVideos: VideoType[]
  latestVideosLoading: boolean
  latestVideosError: { status: number } | null
  reloadLatestVideos: () => Promise<void>

  latestDirects: DirectType[]
  latestDirectsLoading: boolean
  latestDirectsError: { status: number } | null
  reloadLatestDirects: (resetIfNull?: boolean) => Promise<void>

  homeDisplay: number
  currentDirect: DirectType | null
  currentDirectPosterSource: string | null
  homeDisplayLoading: boolean
  homeDisplayError: { status: number } | null
  reloadHomeDisplay: () => Promise<void>

  playlists: PlaylistType[]
  playlistsLoading: boolean
  playlistsError: { status: number } | null
  reloadPlaylists: () => Promise<void>

  motd: string | null
  motdLoading: boolean
  motdError: { status: number } | null
  reloadMotd: () => Promise<void>

  loading: boolean
  reload: () => Promise<void>
}

export const StaticContext = createContext<StaticContextType | undefined>(
  undefined,
)
